module.exports = __webpack_public_path__ + "img/sigin_logo.3a882007.png";